export default "__VITE_ASSET__DLHPBWpw__"